export default {"src":"/_next/static/media/whitemushrooms.56b63b0e.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};